import Vue from 'vue'
import axios from 'axios'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import webBridge from '@/lib/webBridge'
import storage from '../storage'
const codeMessage = {
406: '服务器请求资源格式错误。',
404: '服务器请求资源不存在',
500: '系统内部错误',
502: '网关错误',
503: '服务不可用，服务器暂时过载或维护',
504: '网关超时',
509: '请求过于频繁'
}

const u = navigator.userAgent
const device = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 ? 'Android' : 'iOS'
const version = webBridge.getVersionName()

const service = axios.create({
baseURL: '/apis/', // api的base_url
timeout: 30000, // request timeout,




headers: {
'Content-Type': 'application/json'
}

})


service.interceptors.request.use(
config => {



if (storage.get('_userInfo')) {
config.headers['token'] = storage.get('_userInfo').token
config.headers['device'] = device
config.headers['version'] = version
return config
} else {
return config
}
},
error => {

console.log(error) 
Promise.reject(error)
}
)


service.interceptors.response.use(
/**
* 下面的注释为通过在response里，自定义code来标示请求状态
* 当code返回如下情况则说明权限有问题，登出并返回到登录页
* 如想通过xmlhttprequest来状态码标识 逻辑可写在下面error中
* 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
*/
response => {
if (response.status === 200) {
if (response.data.code === 4010) {
Vue.$vux.toast.show(response.data.msg)
setTimeout(res => {
webBridge.logoutApp()
}, 1500)
webBridge.phoneBomb()
return Promise.reject(response.data)
} else {
if (response.data.code !== 0 && response.data.code != 200) {
webBridge.phoneBomb()
}
return Promise.resolve(response.data)
}
} else {
Vue.$vux.toast.show('错误编码：' + response.status)
webBridge.phoneBomb()
return Promise.reject(response)
}
},
error => {
webBridge.phoneBomb()
if (error.code === 'ECONNABORTED' || error.message === 'Network Error' || !error.response) {
Vue.$vux.toast.show('老铁网络太差啦...<br>换个地方重新试一下')
Vue.$vux.loading.hide()
return Promise.reject({ error: '老铁网络太差啦<br>换个地方重新试一下' })
} else {
const { status } = error.response
const message = codeMessage[status] || '服务异常，您可以试试换个条件或者稍后再试！'
Vue.$vux.toast.show(message)
Vue.$vux.loading.hide()
return Promise.reject({ error: message })
}
}
)

export default service
Vue.prototype.$axios = service
Vue.use(ToastPlugin, {
type: 'text',
position: 'middle',
width: 'auto'
})



// WEBPACK FOOTER //
// ./src/lib/request/request.js